import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/FileArrowDown.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...e, weights: a }));
r.displayName = "FileArrowDownIcon";
const w = r;
export {
  w as FileArrowDown,
  r as FileArrowDownIcon
};
